import { FCX } from "@datassential/platform-ui-lib";
import { Toggle, ToggleType } from "@components/Toggle";
import { KEYWORD_ID, useSelectedKeywordsContext } from "@vms/SelectedKeywords/SelectedKeywordsContext";
import cn from "classnames";
import { useMemo } from "react";

const TableCellSelectKeyword: FCX<{
    tooltipId?: string;
    keywordId: KEYWORD_ID;
    isDisabled?: boolean;
}> = ({
    testId,
    children,
    keywordId,
    tooltipId,
    className,
    isDisabled,
}) => {
    const { selectedKeywordsIds, toggleKeywordSelection } = useSelectedKeywordsContext();
    const onClick = useMemo(
        () => isDisabled ? undefined : () => toggleKeywordSelection(keywordId),
        [isDisabled, toggleKeywordSelection, keywordId]
    );

    return (
        <div
            className={cn('TableCellSelectKeyword', className)}
            data-testid={testId}
            data-tooltip-id={tooltipId}
            onClick={onClick}
            style={{
                cursor: isDisabled ? 'not-allowed' : 'pointer',
            }}
        >
            <Toggle
                modifiers={["inverted"]}
                className="TableCellSelectKeyword__toggle"
                type={ToggleType.RoundCheckbox}
                isChecked={selectedKeywordsIds.includes(keywordId)}
                onChange={() => null}
            />
            {children}
        </div>
    );
};

export default TableCellSelectKeyword;